// LIST
export const GET_WARNINGS = "app/WARNINGS/GET_WARNINGS";
export const GET_WARNINGS_SUCCESS = "app/WARNINGS/GET_WARNINGS_SUCCESS";
export const GET_WARNINGS_FAILURE = "app/WARNINGS/GET_WARNINGS_FAILURE";

export const SAVE_WARNING = "app/WARNINGS/SAVE_WARNING";
export const SAVE_WARNING_SUCCESS = "app/WARNINGS/SAVE_WARNING_SUCCESS";
export const SAVE_WARNING_FAILURE = "app/WARNINGS/SAVE_WARNING_FAILURE";

export const UPDATE_WARNING = "app/WARNINGS/UPDATE_WARNING";
export const UPDATE_WARNING_SUCCESS = "app/WARNINGS/UPDATE_WARNING_SUCCESS";
export const UPDATE_WARNING_FAILURE = "app/WARNINGS/UPDATE_WARNING_FAILURE";

// Dismiss with reason (who / why / when audit)
export const DISMISS_WARNING = "app/WARNINGS/DISMISS_WARNING";
export const DISMISS_WARNING_SUCCESS = "app/WARNINGS/DISMISS_WARNING_SUCCESS";
export const DISMISS_WARNING_FAILURE = "app/WARNINGS/DISMISS_WARNING_FAILURE";

// Record a schedule-review action on an alert (closes the loop anomaly/alert →
// review existing schedules). payload: { uuid, schedule_uuid, action, resolve? }
export const RECORD_SCHEDULE_REVIEW = "app/WARNINGS/RECORD_SCHEDULE_REVIEW";
export const RECORD_SCHEDULE_REVIEW_SUCCESS =
  "app/WARNINGS/RECORD_SCHEDULE_REVIEW_SUCCESS";
export const RECORD_SCHEDULE_REVIEW_FAILURE =
  "app/WARNINGS/RECORD_SCHEDULE_REVIEW_FAILURE";

// "Looks fine" — acknowledge an alert (reviewed, no action). payload: { uuid }
export const ACKNOWLEDGE_WARNING = "app/WARNINGS/ACKNOWLEDGE_WARNING";
export const ACKNOWLEDGE_WARNING_SUCCESS =
  "app/WARNINGS/ACKNOWLEDGE_WARNING_SUCCESS";
export const ACKNOWLEDGE_WARNING_FAILURE =
  "app/WARNINGS/ACKNOWLEDGE_WARNING_FAILURE";

// "Check later" — park an alert for follow-up with a review date.
// payload: { uuid, review_due_at, reason?, note? }
export const MONITOR_WARNING = "app/WARNINGS/MONITOR_WARNING";
export const MONITOR_WARNING_SUCCESS = "app/WARNINGS/MONITOR_WARNING_SUCCESS";
export const MONITOR_WARNING_FAILURE = "app/WARNINGS/MONITOR_WARNING_FAILURE";

// "Actioned" — resolve an alert recording the action taken + note.
// payload: { uuid, action?, note? }
export const RESOLVE_WARNING = "app/WARNINGS/RESOLVE_WARNING";
export const RESOLVE_WARNING_SUCCESS = "app/WARNINGS/RESOLVE_WARNING_SUCCESS";
export const RESOLVE_WARNING_FAILURE = "app/WARNINGS/RESOLVE_WARNING_FAILURE";
